<template>
    <b-card-body v-if="result">
        
        <table class="table table-md mb-3">
            <thead>
                <tr>
                    <th>Connection</th>
                    <th>Orders</th>
                    <th>Customers</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in result" :key="item.store">
                    <td>{{item.connection}}</td>
                    <td>{{item.orders}}</td>
                    <td>{{item.total}}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <th>Total</th>
                    <th>{{ $sum(result, 'orders') }}</th>
                    <th>{{ $sum(result, 'total') }}</th>
                </tr>
            </tfoot>
        </table>

    </b-card-body>
</template>

<script>
import mixin from "../../mixins/area";

export default {
    data: () => ({
        result: null,
    }),
    components: {  },
    watch: {
        entity: {
            deep: true,
            handler() {
                this.getResult();
            }
        }
    },
    computed: {},
    methods: {
        getResult() {
            this.$http.post("/api/module/dashboard/segmentedconnectioncontacts", {
                dates: this.entity.dates,
                user: this.entity.user,
                franchise: this.entity.franchise
            }).then(x => {
                this.result = x.data;
            });
        }
    },
    created() {
        this.getResult();
    },
    mounted() {

    },
    mixins: [mixin]
};
</script>

<style lang="scss">


</style>